import { render, staticRenderFns } from "./NewQueueDialog.vue?vue&type=template&id=e0b974b2"
import script from "./NewQueueDialog.vue?vue&type=script&lang=js"
export * from "./NewQueueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports